<template>
  <div class="">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-list-item link
          v-bind="attrs"
          v-on="on">
          <v-list-item-action>
            <v-icon>mdi-translate</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{langLabel}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-list>
        <v-list-item
          v-for="(value, lang) in langs"
          :key="lang"
          @click="changeLang(lang)"
        >
          <v-list-item-title>{{ value }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: 'locale-changer',
  data () {
    return {
      langs: {
        en: 'English',
        tc: '繁體中文'
      }
    }
  },
  methods: {
    changeLang (key) {
      this.$i18n.locale = key
    }
  },
  computed: {
    langLabel () {
      return this.langs[this.$i18n.locale]
    }
  }
}
</script>
